<div class="error-content narrow">
  @if (hasNoAccess) {
    <div class="error-content-header">
      <svg-icon key="app-window-error-404" fontSize="56px" />
      <h3>No pages are available to you</h3>
    </div>
    <p>Your account doesn't have access to any pages. This usually means no features or roles are assigned to it, or your license grants none. Please contact your administrator.</p>
  } @else {
    <div class="error-content-header">
      <svg-icon key="app-window-error-404" fontSize="56px" />
      <h3>Page not found</h3>
    </div>
    <button class="btn btn-primary" (click)="navigateToDefaultPage()">View homepage</button>
  }
</div>
